//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import * as userApi from '~/api/user';
import * as types from '~/types';

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
    followed: {
      type: Boolean,
      default: false,
    },
    isArrow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('user', ['isFollow', 'isLogin', 'userId']),
  },
  methods: {
    follow() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      if (this.id === this.userId) {
        this.$messagebox.show(
          { title: '格隆汇温馨提示', describe: '不能关注自己！' },
          { cb: () => {}, buttonName: ['确定'] }
        );
      }
      this.$axios(
        userApi.follow({
          id: this.id,
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this[types.FOLLOW](this.id);
            this.$emit('followChange');
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    unfollow() {
      if (!this.isLogin) {
        return;
      }
      this.$axios(
        userApi.unfollow({
          id: this.id,
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this[types.UNFOLLOW](this.id);
            this.$emit('followChange');
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    onClick() {
      if (this.isFollow(this.id) || this.followed) {
        this.unfollow();
      } else {
        this.follow();
      }
    },
    ...mapMutations('user', [
      types.FOLLOW,
      types.UNFOLLOW,
      types.SHOW_LOGIN_FORM,
    ]),
  },
};
